export default {
  accent: "#0a44a5",
  activeColor: "#4b74ff",
  outlineInput: "#c6cbd4",
  placeholderColor: "rgba(31, 31, 31, .5)",
  primaryTextColor: "#222b45",
  secondaryTextColor: "#333333",
  white: "#ffffff",
  backgroundSidebar: "#f7f7f9"
};
